import { Calendar, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function News() {
  const { t, language } = useLanguage();

  const newsItems = language === 'en' ? [
    {
      date: 'December, 2025',
      title: 'New Research Partnership Announced',
      excerpt: 'We are excited to announce a new partnership with leading European institutions to advance AI research in digital literacy and education.',
      image: '/assets/eu.png',
    },
    {
      date: 'November 28, 2025',
      title: 'AI Workshop Series',
      excerpt: 'Join our upcoming workshop series exploring the creative and ethical implications of artificial intelligence and developing responsible AI systems.',
      image: '/assets/workshops.jpg',
    },
    {
      date: 'April, 2024',
      title: 'Digital Literacy Initiative Launch',
      excerpt: 'Our new digital literacy program aims to educate communities about AI technologies and their impact on society.',
      image: 'https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=600',
    },
  ] : [
    {
      date: 'December 2025',
      title: 'Napovedano novo raziskovalno partnerstvo',
      excerpt: 'Z veseljem napovedujemo novo partnerstvo z vodilnimi evropskimi institucijami za napredek raziskav UI na področju digitalne pismenosti in izobraževanja.',
      image: '/assets/eu.png',
    },
    {
      date: 'November 2025',
      title: 'Serija delavnic o etiki UI',
      excerpt: 'Pridružite se naši prihajajoči seriji delavnic, ki raziskujejo etične posledice umetne inteligence in razvoj odgovornih sistemov UI.',
      image: '/assets/workshops.jpg',
    },
    {
      date: '10. november 2025',
      title: 'Začetek pobude za digitalno pismenost',
      excerpt: 'Naš nov program digitalne pismenosti si prizadeva izobražiti skupnosti o tehnologijah UI in njihovem vplivu na družbo.',
      image: 'https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=600',
    },
  ];

  return (
    <section id="news" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('news_title')}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('news_intro')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer border border-gray-100"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center text-gray-500 text-sm mb-3">
                  <Calendar className="w-4 h-4 mr-2" />
                  {item.date}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{item.excerpt}</p>
                <div className="flex items-center text-blue-600 font-semibold group-hover:translate-x-2 transition-transform">
                  <span className="mr-2">Read more</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
